// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"f54c28b0","138":"2462eaf7"}[chunkId] + ".chunk.js";
};